/**
 * Utility function to fetch all dietary requirements on app initialization
 * This ensures that the dietary requirements data is available for ID-to-title mapping
 * when users log in with existing dietary requirement preferences
 */

const fetchAllDietaryRequirements = async () => {
  try {
    const response = await fetch("/api/categories?groupId=3");

    if (!response.ok) {
      console.warn("Failed to fetch dietary requirements:", response.status);
      return { success: false, categories: [] };
    }

    const data = await response.json();
    return { success: true, categories: data.categories || [] };
  } catch (error) {
    console.warn("Error fetching dietary requirements:", error);
    return { success: false, categories: [] };
  }
};

export default fetchAllDietaryRequirements;
